/**
 * Zariknyaa smart search empty state — theme only.
 * Keeps handlers light: no MutationObservers (they froze typing / page reload).
 */
(function () {
  "use strict";

  var POPULAR = [
    "Silk sarees",
    "Banarasi",
    "Wedding",
    "Party wear",
    "Cotton",
    "Red saree",
    "Green saree",
    "Lehenga",
  ];

  var SHOP_BY = [
    { title: "Silk", sub: "Heritage weaves", q: "silk" },
    { title: "Wedding", sub: "Bridal edit", q: "wedding" },
    { title: "Party", sub: "Evening looks", q: "party" },
    { title: "Cotton", sub: "Everyday ease", q: "cotton" },
  ];

  var PLACEHOLDER = "Search sarees, colours & occasions…";
  var PANEL_ID = "zk-smart-search";

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function chipSvg() {
    return (
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<circle cx="11" cy="11" r="6.5" stroke="currentColor" stroke-width="1.6"/>' +
      '<path d="M16 16l4.2 4.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
      "</svg>"
    );
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function escapeAttr(s) {
    return escapeHtml(s).replace(/'/g, "&#39;");
  }

  function eachShell(fn) {
    var nodes = document.querySelectorAll("search-modal");
    if (!nodes.length) {
      var one = qs(".search-modal");
      if (one) fn(one);
      return;
    }
    for (var i = 0; i < nodes.length; i++) fn(nodes[i]);
  }

  function getDetails(shell) {
    if (!shell) return null;
    if (shell.tagName === "DETAILS") return shell;
    return qs("details", shell);
  }

  function getInput(shell) {
    return qs('input.search__input, input[type="search"]', shell);
  }

  function syncPanel(shell) {
    var panel = document.getElementById(PANEL_ID);
    var input = getInput(shell) || qs('input.search__input, input[type="search"]');
    if (!panel || !input) return;
    var hasQuery = !!String(input.value || "").trim();
    var shouldHide = hasQuery;
    if (panel.hidden === shouldHide) return;
    panel.hidden = shouldHide;
  }

  function fillAndSearch(term, shell) {
    var input = getInput(shell) || qs('input.search__input, input[type="search"]');
    if (!input) return;
    input.focus();
    input.value = term;
    input.dispatchEvent(new Event("input", { bubbles: true }));
    syncPanel(shell);
  }

  function ensurePanel(shell) {
    var existing = document.getElementById(PANEL_ID);
    if (existing) return existing;

    var field = qs("form.search .field, .search-modal__form .field", shell);
    if (!field || !field.parentNode) return null;

    var panel = document.createElement("div");
    panel.id = PANEL_ID;
    panel.className = "zk-smart";
    panel.setAttribute("role", "region");
    panel.setAttribute("aria-label", "Smart search suggestions");

    panel.innerHTML =
      '<div class="zk-smart__block">' +
      '<p class="zk-smart__label">Popular searches</p>' +
      '<div class="zk-smart__chips">' +
      POPULAR.map(function (term) {
        return (
          '<button type="button" class="zk-smart__chip" data-zk-q="' +
          escapeAttr(term) +
          '">' +
          chipSvg() +
          "<span>" +
          escapeHtml(term) +
          "</span></button>"
        );
      }).join("") +
      "</div></div>" +
      '<div class="zk-smart__block">' +
      '<p class="zk-smart__label">Shop by style</p>' +
      '<div class="zk-smart__tiles">' +
      SHOP_BY.map(function (item) {
        return (
          '<a class="zk-smart__tile" href="/search?q=' +
          encodeURIComponent(item.q) +
          '"><b>' +
          escapeHtml(item.title) +
          "</b><span>" +
          escapeHtml(item.sub) +
          "</span></a>"
        );
      }).join("") +
      "</div></div>" +
      '<p class="zk-smart__hint">Try a colour, fabric, or occasion — we’ll suggest matching pieces as you type.</p>';

    field.parentNode.insertBefore(panel, field.nextSibling);

    panel.addEventListener("click", function (e) {
      var btn = e.target.closest("button.zk-smart__chip[data-zk-q]");
      if (!btn || !panel.contains(btn)) return;
      e.preventDefault();
      fillAndSearch(btn.getAttribute("data-zk-q") || "", shell);
    });

    return panel;
  }

  function onOpen(shell) {
    var input = getInput(shell);
    if (input && input.getAttribute("placeholder") !== PLACEHOLDER) {
      input.setAttribute("placeholder", PLACEHOLDER);
    }
    ensurePanel(shell);
    syncPanel(shell);

    if (input && !input.dataset.zkSmartBound) {
      input.dataset.zkSmartBound = "1";
      input.addEventListener("input", function () {
        syncPanel(shell);
      });
    }
  }

  function bindShell(shell) {
    if (!shell || shell.dataset.zkSmartInit) return;
    shell.dataset.zkSmartInit = "1";

    var details = getDetails(shell);
    if (!details) return;

    details.addEventListener("toggle", function () {
      if (details.open) onOpen(shell);
    });

    var summary = qs("summary", shell) || qs("summary", details);
    if (summary) {
      summary.addEventListener("click", function () {
        // details.open flips after click; run next frame
        requestAnimationFrame(function () {
          if (details.open) onOpen(shell);
        });
      });
    }

    if (details.open) onOpen(shell);
  }

  function bind() {
    eachShell(bindShell);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
})();
